var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53344 20.9168L2.22714 11.7839C1.77232 11.2154 1.54491 10.9311 1.38319 10.6146C1.23972 10.3338 1.13486 10.0348 1.07146 9.72592C1 9.37772 1 9.01369 1 8.28563V7.1C1 5.13982 1 4.15972 1.38148 3.41103C1.71703 2.75247 2.25247 2.21703 2.91103 1.88148C3.65972 1.5 4.63982 1.5 6.6 1.5H23.4C25.3602 1.5 26.3403 1.5 27.089 1.88148C27.7475 2.21703 28.283 2.75247 28.6185 3.41103C29 4.15972 29 5.13982 29 7.1V8.28563C29 9.01369 29 9.37772 28.9285 9.72592C28.8651 10.0348 28.7603 10.3338 28.6168 10.6146C28.4551 10.9311 28.2277 11.2154 27.7729 11.7839L20.4666 20.9168M2.75009 3.24999L15.0001 19L27.2499 3.24999M21.1872 21.5628C24.6043 24.9799 24.6043 30.5201 21.1872 33.9372C17.7701 37.3543 12.2299 37.3543 8.81281 33.9372C5.39573 30.5201 5.39573 24.9799 8.81281 21.5628C12.2299 18.1457 17.7701 18.1457 21.1872 21.5628Z",
    stroke: "#FF5D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityBadge);
export default __webpack_public_path__ + "static/media/quality-badge.f5f9c198ac59f86b48b02d75556b44e9.svg";
export { ForwardRef as ReactComponent };